module.exports = "<router-outlet name=\"details\"></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/containers/customer/customer-container.component.html
// module id = ../../../../../src/app/containers/customer/customer-container.component.html
// module chunks = main